import { UserId, SecondaryArtwork } from "kreate-common/modules/business-types";
import { z } from "zod";

import { BooleanField } from "../../utils/customType";

const TraitEntries$Params = z.any().transform((params) => {
  const obj = typeof params === "string" ? JSON.parse(params) : params;
  return z.tuple([z.string(), z.string().array()]).array().parse(obj);
});

export const Params = z.object({
  /** function optionals */
  shouldCountTotalItems: BooleanField.optional(),
  // filter by name
  searchQuery: z.string().optional(),
  /** filtering by knowned params */
  // by asset
  assetId: UserId.optional(),
  // by owner
  /** @deprecated use ownerStakeAddress insteads */
  ownerId: UserId.optional(),
  ownerStakeAddress: z.string().optional(),
  // by artist
  authorId: UserId.optional(),
  policyId: z.string().optional(),
  /** @deprecated use `traitEntries` instead */
  traitKey: z.string().optional(),
  /** @deprecated use `traitEntries` instead */
  traitValue: z.string().optional(),
  traitEntries: TraitEntries$Params.optional(),
  // for sale filtering
  forSale: BooleanField.optional(),
  isSingleEdition: BooleanField.optional(),
  // sorting and paginating
  offset: z.coerce.number().optional(),
  limit: z.coerce.number().optional(),
  orderBy: z.enum(["best_price", "minted_at", "listed_at"]).optional(),
  orderDirection: z.enum(["asc", "desc"]).optional(),
});

export type Params = z.infer<typeof Params>;

export const Result = z.object({
  artworks: SecondaryArtwork.array(),
  count: z.number().nullish(),
});

export type Result = z.infer<typeof Result>;

export type GetSecondaryArtworkList$Params = Params;
export const GetSecondaryArtworkList$Params = Params;
export type GetSecondaryArtworkList$Result = Result;
export const GetSecondaryArtworkList$Result = Result;
